import { useCallback, useMemo } from 'react';
import { isAfter, startOfDay } from 'date-fns';
import { StartAutomaticBillingAtControlDropdownMenuItem } from '../StartAutomaticBillingAtControl';
export const useMenuItems = (param)=>{
    let { isBilledUpfront, relationshipEffectiveDate, isAmendedService, getToday } = param;
    const isRelationshipEffectiveDateIsInTheFuture = useMemo(()=>{
        if (relationshipEffectiveDate) {
            return isAfter(startOfDay(relationshipEffectiveDate), getToday());
        }
        return false;
    }, [
        relationshipEffectiveDate
    ]);
    const getOnEffectiveDateText = useCallback(()=>{
        if (isAmendedService) {
            return {
                value: StartAutomaticBillingAtControlDropdownMenuItem.AcceptanceDate,
                text: 'Issue an invoice immediately',
                subtext: 'An invoice for this service will be issued immediately once amendments are saved in addition to the invoices issued on the upcoming billing date and going forward. Invoices including this service will require an approval from your client until this amendment is approved.'
            };
        }
        if (isRelationshipEffectiveDateIsInTheFuture) {
            return {
                value: StartAutomaticBillingAtControlDropdownMenuItem.AcceptanceDate,
                text: 'Start billing on agreement effective date',
                subtext: 'The service will be charged on the effective date of the agreement (even if it’s not the set billing day) and continue issuing from the next scheduled billing date and going forward.'
            };
        }
        return {
            value: StartAutomaticBillingAtControlDropdownMenuItem.AcceptanceDate,
            text: 'Start billing on proposal acceptance',
            subtext: 'The service will be charged on the day the proposal is accepted (even if it’s not the set billing day) and continue issuing from the next scheduled billing date and going forward.'
        };
    }, [
        isRelationshipEffectiveDateIsInTheFuture,
        isAmendedService
    ]);
    const menuItems = useMemo(()=>{
        return [
            {
                value: StartAutomaticBillingAtControlDropdownMenuItem.SpecificDate,
                text: 'Start billing on a specific date',
                subtext: 'Choose a start date for automatic billing of this service. If the date has already passed or the proposal is accepted after that date, invoices for prior periods will be issued automatically.'
            },
            ...isBilledUpfront ? [
                getOnEffectiveDateText()
            ] : [],
            {
                value: StartAutomaticBillingAtControlDropdownMenuItem.Pause,
                text: "Don't start automatic billing",
                subtext: 'The service will not be billed until you manually initiate automatic billing for it.'
            }
        ];
    }, [
        isBilledUpfront,
        getOnEffectiveDateText
    ]);
    return menuItems;
};
